export default function serialAll(promiseFactories) {
    let chain = Promise.resolve([]);
    promiseFactories.forEach(promiseFactory => {
        chain = chain
            .then(chainedRes =>
                promiseFactory().then(res => [...chainedRes, res]));
    });
    return chain;
};
